// client/src/App.tsx
import React from 'react';
import { ChakraProvider } from '@chakra-ui/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';

// Pages
import Welcome from './pages/play/Welcome';
import CapturePhoto from './pages/play/CapturePhoto';
import Quiz from './pages/play/Quiz';
import EndRedirect from './pages/play/EndRedirect';
import SoulReveal from './pages/reveal/SoulReveal';

// Shared background images for all routes
const backgroundImages = [
  '/images/quiz-bg1.png',
  '/images/quiz-bg2.png',
  '/images/quiz-bg3.png',
  '/images/quiz-bg4.png',
  '/images/quiz-bg5.png',
  '/images/quiz-bg6.png',
  '/images/quiz-bg7.png',
  '/images/quiz-bg8.png',
  '/images/quiz-bg9.png',
  '/images/quiz-bg10.png',
  '/images/quiz-bg11.png',
  '/images/quiz-bg12.png',
];

const queryClient = new QueryClient();

function App() {

  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider>
        <Router>
          <Routes>
            {/* Play flow routes */}
            <Route path="/play" element={
              <Layout images={backgroundImages}>
                <Welcome />
              </Layout>
            } />
            <Route path="/play/capture" element={
              <Layout images={backgroundImages}>
                <CapturePhoto />
              </Layout>
            } />
            <Route path="/play/quiz" element={
              <Layout images={backgroundImages}>
                <Quiz />
              </Layout>
            } />
            <Route path="/play/end" element={
              <Layout images={backgroundImages}>
                <EndRedirect />
              </Layout>
            } />
            
            {/* Reveal flow routes */}
            <Route path="/reveal/:userId" element={
              <Layout images={backgroundImages}>
                <SoulReveal />
              </Layout>
            } />
            
            {/* Redirect root to play */}
            <Route path="/" element={
              <Layout images={backgroundImages}>
                <Welcome />
              </Layout>
            } />
          </Routes>
        </Router>
      </ChakraProvider>
    </QueryClientProvider>
  );
}

export default App;
